import {
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
} from '@angular/core';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as moment from 'moment';

@Component({
  selector: 'app-html-to-pdf',
  templateUrl: './html-to-pdf.component.html',
  styleUrls: ['./html-to-pdf.component.scss'],
})
export class HtmlToPdfComponent {
  @ViewChild('pdfTable', { static: false }) pdfTable: ElementRef;
  typeDemand: any[] = [];
  typeFixed: any[] = [];
  typeTerm: any[] = [];
  fs_Pdf_Data: any;
  isSingleType = true;
  logoUrl = '../../../assets/images/logos/convertibill-logo.png';
  stampUrl = '../../../assets/images/logos/convertBill-stamp.png';
  @Output() pdfGenerated: EventEmitter<boolean> = new EventEmitter<boolean>();

  public async downloadAsPDF(
    fileName: string,
    fs_Pdf_Data: any,
    startDate: string,
    endDate: string,
    debtorType: string,
  ): Promise<void> {
    const data = this.pdfTable.nativeElement;
    this.fs_Pdf_Data = fs_Pdf_Data;

    const allData = fs_Pdf_Data;
    const doc = new jsPDF('p', 'pt', 'a4');
    const options = {
      background: 'white',
      scale: 3,
    };
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 15;
    const headerHeight = 20;
    const footerHeight = 40;
    const effectivePageHeight =
      pageHeight - headerHeight - footerHeight - 2 * margin;

    const renderPage = async (
      htmlContent: string,
      pageNumber: number,
      totalPages: number,
    ) => {
      data.innerHTML = htmlContent;
      data.style.width = '1150px';
      const canvas = await html2canvas(data, options);
      const imgWidth = doc.internal.pageSize.getWidth();
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      const imgData = canvas.toDataURL('image/jpeg', 0.8);
      const position = margin + headerHeight;
      if (pageNumber === 1) {
        doc.addImage(
          imgData,
          'JPEG',
          margin,
          position,
          imgWidth - 2 * margin,
          Math.min(effectivePageHeight, imgHeight),
        );
      } else {
        doc.addPage();
        doc.addImage(
          imgData,
          'JPEG',
          margin,
          position,
          imgWidth - 2 * margin,
          Math.min(effectivePageHeight, imgHeight),
        );
      }
      this.addHeader(doc);
      this.addFooter(doc, pageNumber, totalPages);
    };

    const generatePDF = async (allData: string | any[], debtorType: string) => {
      let pageNumber = 1;
      const totalPages = 2;
      const htmlContentForPage1 = this.htmlTable(
        startDate,
        endDate,
        debtorType,
      );
      await renderPage(htmlContentForPage1, pageNumber, totalPages);
      const htmlContentForPage2 = this.htmlTableForPage2(
        startDate,
        endDate,
        debtorType,
      );
      pageNumber = 2;
      await renderPage(htmlContentForPage2, pageNumber, totalPages);
    };

    await generatePDF(allData, debtorType);
    const pdfBlob = doc.output('blob');
    const downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(pdfBlob);
    downloadLink.download = `${fileName}.pdf`;
    downloadLink.click();
    window.open(URL.createObjectURL(pdfBlob), '_blank');
    this.pdfGenerated.emit(true);
  }

  htmlTable(startDate: string, endDate: string, debtorType: string) {
    let tableBody = `
      <header>
        <table style="width: 100%;">
          <tr>
            <td style="text-align: left; vertical-align: top;"></td>
            <td style="float: right;">
              <p style="line-height: 22px; font-size: 17px; font-weight: 600; margin-bottom: 2px;">Credebt Exchange Limited</p>
              <p style="line-height: 22px; font-size: 15px;">15A Baggotrath Place, 15 - 16<br> Lower Baggot Street,<br>Dublin D02 NX49, Ireland</p>
              <p style="line-height: 22px; font-size: 15px;">Phone : +353 (1) 685-3600</p>
              <p style="line-height: 22px; font-size: 15px;">Email: mailto:yield@investabill.com</p>
            </td>
          </tr>
          <tr>
            <td height="25px"></td>
          </tr>
          <tr>
            <td colspan="3" style="text-align: center;">
              <h1 style="font-weight: 600;">Originator Statement</h1>
            </td>
          </tr>
          <tr>
            <td height="30px"></td>
          </tr>
          <tr>
            <td style="vertical-align: top;">
              <div class="account-info">
                <h4>The Tipperary Cheese Company Limited</h4>
                <p>Thurles</p>
              </div>
            </td>
            <td>
              <table class="statement-header-table">
                <tr>
                  <td>
                    <p>From</p>
                    <p>Issue Date</p>
                    <p>ID</p>
                  </td>
                  <td>
                    <p>:</p>
                    <p>:</p>
                    <p>:</p>
                  </td>
                  <td>
                    <p>&nbsp;Trade Desk</p>
                    <p>&nbsp;02 November 2024</p>
                    <p>&nbsp;11307000041</p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td style="height: 20px;"></td>
          </tr>
        </table>
        <hr>
      </header>
      <section class="transactions">
        <div class="data-table-outer">
          <table class="data-table overide-statement">
            <thead>
              <tr>
                <th colspan="4">Statement Details</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style="font-weight: 700; font-size:18px;">Statement From</td>
                <td>${startDate}</td>
                <td style="font-weight: 700; font-size:18px;">Statement To </td>
                <td>${endDate}</td>
              </tr>
            </tbody>
          </table>
          <table class="data-table">
            <thead>
              <tr>
                <th>Sales Ledger</th>
                <th>EUR Credit</th>
                <th>EUR Debit</th>
              </tr>
            </thead>
            <tbody>
    `;

    if (debtorType === 'Debtor Statement') {
      tableBody += `
        <tr>
          <td style="color: #000;text-align:left;">Opening Traded Balance</td>
          <td></td>
          <td style="text-align:right;color: #000;">355,132.39</td>
        </tr>
        <tr>
          <td style="color: #000;text-align:left;">Trades in the period</td>
          <td></td>
          <td style="text-align:right;color: #000;">214,149.03</td>
        </tr>
        <tr>
          <td style="color: #000;text-align:left;">Credit Notes</td>
          <td style="text-align:right;color: #000;">0.00</td>
          <td></td>
        </tr>
        <tr>
          <td style="color: #000;text-align:left;">Specific Deductions</td>
          <td style="text-align:right;color: #000;">3,065.08</td>
          <td></td>
        </tr>
        <tr>
          <td style="color: #000;text-align:left;">Returned Payments</td>
          <td></td>
          <td style="text-align:right;color: #000;">0.00</td>
        </tr>
        <tr>
          <td style="color: #000;text-align:left;">Receipts in the period</td>
          <td style="text-align:right;color: #000;">229,261.18</td>
          <td></td>
        </tr>
        <tr>
          <td style="color: #000;text-align:left;">Closing Balance</td>
          <td></td>
          <td style="text-align:right;color: #000;">336,955.16</td>
        </tr>
        <tr>
          <td style="color: #000;text-align:left;">Sell Rate</td>
          <td></td>
          <td style="text-align:right;color: #000;">8,818.53</td>
        </tr>
        <tr>
          <td style="color: #000;text-align:left;">Trade Commission</td>
          <td></td>
          <td style="text-align:right;color: #000;">194.30</td>
        </tr>
        <tr>
          <td style="color: #000;text-align:left;">Processing Commission (ETR & Reserves)</td>
          <td></td>
          <td style="text-align:right;color: #000;">240.00</td>
        </tr>
        <tr>
          <td style="color: #000;text-align:left;">Processing Commission (Returned Payments)</td>
          <td></td>
          <td style="text-align:right;color: #000;">0.00</td>
        </tr>
      `;
      tableBody += `
        </tbody>
        <tfoot>
          <tr>
            <td style="text-align:left;color: #000;font-weight:bold;">Total Commissions in the period</td>
            <td></td>
            <td style="text-align:right;color: #000;font-weight:bold;">9,252.83</td>
          </tr>
        </tfoot>
      `;
    } else if (debtorType === 'Creditor Statement') {
      tableBody += `
        <tr>
          <td style="color: #000;text-align:left;">Opening Traded Balance</td>
          <td></td>
          <td style="text-align:right;color: #000;">104,839.18</td>
        </tr>
        <tr>
          <td style="color: #000;text-align:left;">Trades in the period</td>
          <td></td>
          <td style="text-align:right;color: #000;">163,319.51</td>
        </tr>
        <tr>
          <td style="color: #000;text-align:left;">Returned Payments</td>
          <td></td>
          <td style="text-align:right;color: #000;">2,814.05</td>
        </tr>
        <tr>
          <td style="color: #000;text-align:left;">Receipts in the period</td>
          <td style="text-align:right;color: #000;">100,367.86</td>
          <td></td>
        </tr>
        <tr>
          <td style="color: #000;text-align:left;">Sell Rate</td>
          <td></td>
          <td style="text-align:right;color: #000;">1,613.18</td>
        </tr>
        <tr>
          <td style="color: #000;text-align:left;">Trade Commission</td>
          <td></td>
          <td style="text-align:right;color: #000;">11.60</td>
        </tr>
        <tr>
          <td style="color: #000;text-align:left;">Processing Commission (ETR)</td>
          <td></td>
          <td style="text-align:right;color: #000;">20.00</td>
        </tr>
        <tr>
          <td style="color: #000;text-align:left;">Processing Commission (Returned Payments)</td>
          <td></td>
          <td style="text-align:right;color: #000;">10.00</td>
        </tr>
      `;
      tableBody += `
        </tbody>
        <tfoot>
          <tr>
            <td style="text-align:left;color: #000;font-weight:bold;">Total Commissions in the period</td>
            <td></td>
            <td style="text-align:right;color: #000;font-weight:bold;">1,654.78</td>
          </tr>
          <tr>
            <td style="text-align:left;color: #000;font-weight:bold;">Closing Balance</td>
            <td></td>
            <td style="text-align:right;color: #000;font-weight:bold;">172,259.66</td>
          </tr>
        </tfoot>
      `;
    }

    tableBody += `
          </table>
        </div>
      </section>
     
    `;
    return this.commonStyles() + tableBody;
  }

  htmlTableForPage2(startDate: string, endDate: string, debtorType: string) {
    let tableBody = `
    <header>
      <table style="width: 100%;">
        <tr>
          <td style="text-align: left; vertical-align: top;"></td>
          <td style="float: right;">
            <p style="line-height: 22px; font-size: 17px; font-weight: 600; margin-bottom: 2px;">Credebt Exchange Limited</p>
            <p style="line-height: 22px; font-size: 15px;">15A Baggotrath Place, 15 - 16<br> Lower Baggot Street,<br>Dublin D02 NX49, Ireland</p>
            <p style="line-height: 22px; font-size: 15px;">Phone : +353 (1) 685-3600</p>
            <p style="line-height: 22px; font-size: 15px;">Email: mailto:yield@investabill.com</p>
          </td>
        </tr>
        <tr>
          <td height="25px"></td>
        </tr>
        <tr>
          <td colspan="3" style="text-align: center;">
            <h1 style="font-weight: 600;">Originator Statement</h1>
          </td>
        </tr>
        <tr>
          <td height="30px"></td>
        </tr>
        <tr>
          <td style="vertical-align: top;">
            <div class="account-info">
              <h4>The Tipperary Cheese Company Limited</h4>
              <p>Thurles</p>
            </div>
          </td>
          <td>
            <table class="statement-header-table">
              <tr>
                <td>
                  <p>From</p>
                  <p>Issue Date</p>
                  <p>ID</p>
                </td>
                <td>
                  <p>:</p>
                  <p>:</p>
                  <p>:</p>
                </td>
                <td>
                  <p>&nbsp;Trade Desk</p>
                  <p>&nbsp;02 November 2024</p>
                  <p>&nbsp;11307000041</p>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td style="height: 20px;"></td>
        </tr>
      </table>
      <hr>
    </header>
    <section class="transactions">
      <div class="data-table-outer">
        <table class="data-table overide-statement">
          <thead>
            <tr>
              <th colspan="4">Statement Details</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="font-weight: 700; font-size:18px;">Statement From</td>
              <td>${startDate}</td>
              <td style="font-weight: 700; font-size:18px;">Statement To </td>
              <td>${endDate}</td>
            </tr>
          </tbody>
        </table>
        <table class="data-table">
          <thead>
           <tr>
                <th>Sales Ledger</th>
                <th>GBP Credit</th>
                <th>GBP Debit</th>
              </tr>
          </thead>
          <tbody>
  `;

    if (debtorType === 'Debtor Statement') {
      tableBody += `
      <tr>
        <td style="color: #000;text-align:left;">Opening Traded Balance</td>
        <td></td>
        <td style="text-align:right;color: #000;">280,550.99</td>
      </tr>
      <tr>
        <td style="color: #000;text-align:left;">Trades in the period</td>
        <td></td>
        <td style="text-align:right;color: #000;">182,042.09</td>
      </tr>
      <tr>
        <td style="color: #000;text-align:left;">Credit Notes</td>
        <td style="text-align:right;color: #000;">1,631.35</td>
        <td></td>
      </tr>
      <tr>
        <td style="color: #000;text-align:left;">Specific Deductions</td>
        <td style="text-align:right;color: #000;">448.42</td>
        <td></td>
      </tr>
      <tr>
        <td style="color: #000;text-align:left;">Returned Payments</td>
        <td></td>
        <td style="text-align:right;color: #000;">0.00</td>
      </tr>
      <tr>
        <td style="color: #000;text-align:left;">Receipts in the period</td>
        <td style="text-align:right;color: #000;">183,204.63</td>
        <td></td>
      </tr>
      <tr>
        <td style="color: #000;text-align:left;">Closing Balance</td>
        <td></td>
        <td style="text-align:right;color: #000;">277,308.68</td>
      </tr>
      <tr>
        <td style="color: #000;text-align:left;">Sell Rate</td>
        <td></td>
        <td style="text-align:right;color: #000;">7,119.79</td>
      </tr>
      <tr>
        <td style="color: #000;text-align:left;">Trade Commission</td>
        <td></td>
        <td style="text-align:right;color: #000;">104.40</td>
      </tr>
      <tr>
        <td style="color: #000;text-align:left;">Processing Commission (ETR & Reserves)</td>
        <td></td>
        <td style="text-align:right;color: #000;">260.00</td>
      </tr>
      <tr>
        <td style="color: #000;text-align:left;">Processing Commission (Returned Payments)</td>
        <td></td>
        <td style="text-align:right;color: #000;">0.00</td>
      </tr>
    `;
      tableBody += `
      </tbody>
      <tfoot>
        <tr>
          <td style="text-align:left;color: #000;font-weight:bold;">Total Commissions in the period</td>
          <td></td>
          <td style="text-align:right;color: #000;font-weight:bold;">7,484.19</td>
        </tr>
      </tfoot>
    `;
    } else if (debtorType === 'Creditor Statement') {
      tableBody += `
      <tr>
        <td style="color: #000;text-align:left;">Opening Traded Balance</td>
        <td></td>
        <td style="text-align:right;color: #000;">328.55</td>
      </tr>
      <tr>
        <td style="color: #000;text-align:left;">Trades in the period</td>
        <td></td>
        <td style="text-align:right;color: #000;">0.00</td>
      </tr>
      <tr>
        <td style="color: #000;text-align:left;">Returned Payments</td>
        <td></td>
        <td style="text-align:right;color: #000;">0.00</td>
      </tr>
      <tr>
        <td style="color: #000;text-align:left;">Receipts in the period</td>
        <td style="text-align:right;color: #000;">0.00</td>
        <td></td>
      </tr>
      <tr>
        <td style="color: #000;text-align:left;">Sell Rate</td>
        <td></td>
        <td style="text-align:right;color: #000;">0.00</td>
      </tr>
      <tr>
        <td style="color: #000;text-align:left;">Trade Commission</td>
        <td></td>
        <td style="text-align:right;color: #000;">0.00</td>
      </tr>
      <tr>
        <td style="color: #000;text-align:left;">Processing Commission (ETR)</td>
        <td></td>
        <td style="text-align:right;color: #000;">0.00</td>
      </tr>
      <tr>
        <td style="color: #000;text-align:left;">Processing Commission (Returned Payments)</td>
        <td></td>
        <td style="text-align:right;color: #000;">0.00</td>
      </tr>
    `;
      tableBody += `
      </tbody>
      <tfoot>
        <tr>
          <td style="text-align:left;color: #000;font-weight:bold;">Total Commissions in the period</td>
          <td></td>
          <td style="text-align:right;color: #000;font-weight:bold;">0.00</td>
        </tr>
        <tr>
          <td style="text-align:left;color: #000;font-weight:bold;">Closing Balance</td>
          <td></td>
          <td style="text-align:right;color: #000;font-weight:bold;">328.55</td>
        </tr>
      </tfoot>
    `;
    }

    tableBody += `
            </table>
        </div>
      </section>
  `;

    return this.commonStyles() + tableBody;
  }
  addHeader(doc: jsPDF) {
    const margin = 15;
    const imageWidth = 200; // Adjust width as needed
    const imageHeight = 50; // Adjust height as needed
    doc.addImage(this.logoUrl, 'PNG', margin, margin, imageWidth, imageHeight);
  }

  addFooter(doc: jsPDF, pageNumber: number, totalPages: number) {
    const margin = 2;
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const currentDate = moment().format('YYYY-MM-DD'); // Get the current date in the required format
    doc.setFontSize(10);
    doc.text(
      `Page ${pageNumber} of ${totalPages}`,
      pageWidth - margin - 70,
      pageHeight - margin - 20,
    );

    // Add stamp to the last page
    if (pageNumber === totalPages) {
      const stampWidth = 50;
      const stampHeight = 50;
      const stampX = pageWidth - margin - stampWidth;
      const stampY = pageHeight - margin - stampHeight;
      doc.addImage(
        this.stampUrl,
        'PNG',
        stampX - 20,
        stampY - 60,
        stampWidth,
        stampHeight,
      );

      // Add the date below the stamp image
      doc.setFontSize(10);
      doc.setFont('helvetica', 'bold');
      doc.text(currentDate, stampX - 20, stampY - 50 + stampHeight + 10);
    }
  }

  commonStyles() {
    return `
     <style>
        img, ul, h1, h2, h3, h4, h5, h6, p { margin: 0px; padding: 0px; }
        * { margin: 0px; padding: 0px; }
        a { text-decoration: none; transition: all .5s ease-in-out; }
        a:hover { text-decoration: none; }
        .statement { width: 1050px; margin: auto; background: #fff; padding: 10px 40px; position: relative; }
        h1 { font-size: 24px; font-weight: 500; }
        .bank-name, .statement-date { margin: 5px 0; }
        .account-info h4 { font-size: 18px; font-weight: 700; }
        .account-info p { font-size: 16px; margin-top: 8px; }
        .data-table-outer { margin-top: 20px; margin-bottom: 40px; }
        .data-table.overide-statement { margin-bottom: 20px; }
        .data-table { width: 100%; border-collapse: collapse; border: 1px solid #3d4856; }
        .data-table tr:nth-child(even) { background-color: #f2f2f2; }
        .data-table th { background: #3d4856; color: #fff; }
        .data-table, .data-table th, .data-table td { border: 1px solid #54667a; }
        .data-table th, .data-table td { padding: 5px 5px; text-align: center; font-size: 15px;}
        h2 { font-size: 22px; font-weight: 500; margin-bottom: 6px; }
        .statement-header-table { margin-top: 0; width: 350px; margin-left: auto; }
        .investor-detail p { padding-top: 8px; }
        .investor-detail.summery { padding-top: 12px; }
        .investor-detail.summery p { font-weight: 600; }
        .investor-detail p span { display: inline-block; width: 50px; }
        .statement-header-table p { margin-top: 8px; font-size: 16px; min-height: 18px; }
        .transactions { margin-top: 0px; padding-top: 0px; }
        .total-text { display: block; text-align: right; width: 112px; }
        .data-table .text-right { text-align: right; }
        .statement.statement-2 .data-table-outer { height: unset; }
        .stamp-and-date { background: rgba(235, 255, 241, 1); }
        .statement .stamp-and-date { background-color: #fff; text-align: right; margin-top: 60px; }
        .statement .stamp-and-date p { font-size: 16px; padding-top: 10px; font-weight: 600; }
        .pagination { padding: 0px 0px; position: absolute; bottom: 0; right: 0; }
        .pagination ul { display: flex; align-items: center; justify-content: end; list-style: none; column-gap: 12px; }
        .pagination ul li a { color: #000; }
        .white-space { height: 250px; }
      </style>
       `;
  }
}
